import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

import { iconClose, iconCloseHover } from "./icons";

const Modal = ({
  visible,
  width,
  height,
  className,
  children,
  onToggle,
  backdrop,
  fullScreenMobile,
  onLabelClosed,
  onLabelTextClosed,
  backdropTransparent,
  redHoverClosed,
  footer,
  max12Padding,
  degradedTop,
  degradedBottom,
  confirmModal,
  fullScreen,
  hideCloseButton,
  refBody
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (visible !== open) {
      setOpen(visible);
    }
  }, [visible]);

  const handleToggle = () => {
    setOpen(!open);

    if (onToggle) {
      onToggle(!open);
    }
  };

  const handleBackdropClick = () => {
    if (backdrop) {
      handleClose();
    }
  };

  const handleClose = () => {
    setOpen(false);

    if (onToggle) {
      onToggle(false);
    }
  };

  return (
    <div
      className={clsx("rd--modal", className, {
        active: open,
        "rd--modal__confirm": confirmModal,
        "rd--modal__fullscreen": fullScreen,
        "rd--modal__fullscreen-mobile": fullScreenMobile,
        "rd--modal__label-closed": onLabelClosed,
        "rd--modal__label-closed-hovered": redHoverClosed,
        "rd--modal__has--footer": footer,
        "rd--modal__max-12-padding": max12Padding,
        "rd--modal__degraded": degradedBottom || degradedTop
      })} >
      {!backdropTransparent && (
        <div className="rd--modal__shadow" onClick={handleBackdropClick} />
      )}
      <div className="rd--modal__content" style={{ maxWidth: width, maxHeight: height}}>
        {!hideCloseButton && (
          <div className="rd--modal__close" onClick={handleToggle}>
            {onLabelClosed && (
              <span className="rd--modal__close-label">
                {onLabelTextClosed}
              </span>
            )}
            {iconClose}
            {iconCloseHover}
          </div>
        )}
        <div ref={refBody} className="rd--modal__body">
          {degradedTop && <div className="rd--modal__scrolled-top" />}
          {children}
          {degradedBottom && <div className="rd--modal__scrolled-bottom" />}
        </div>
        {footer && <div className="rd--modal__footer">{footer}</div>}
      </div>
    </div>
  );
};

Modal.propTypes = {
  visible: PropTypes.bool.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  onToggle: PropTypes.func.isRequired,
  backdrop: PropTypes.bool,
  fullScreenMobile: PropTypes.bool,
  onLabelClosed: PropTypes.bool,
  onLabelTextClosed: PropTypes.string,
  backdropTransparent: PropTypes.bool,
  redHoverClosed: PropTypes.bool,
  footer: PropTypes.node,
  max12Padding: PropTypes.bool,
  degradedTop: PropTypes.bool,
  degradedBottom: PropTypes.bool,
  confirmModal: PropTypes.bool,
  fullScreen: PropTypes.bool,
  hideCloseButton: PropTypes.bool,
  refBody: PropTypes.bool
};

Modal.defaultProps = {
  visible: false,
  width: "100%",
  height: "100%",
  className: "",
  children: null,
  onToggle: () => {},
  backdrop: false,
  fullScreenMobile: false,
  onLabelClosed: false,
  onLabelTextClosed: "",
  backdropTransparent: false,
  redHoverClosed: false,
  footer: null,
  max12Padding: false,
  degradedTop: false,
  degradedBottom: false,
  confirmModal: false,
  fullScreen: false,
  hideCloseButton: false,
  refBody: null
};

export default Modal;
